import { NotificationService, CONSTANT, LoaderService, ErrorService, EVENTO, TOOLTIPS, ICONS, ACTIONS, UtilityService } from "../../../../shared/session/index";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { Office, Ioffice } from "../shared/office.model";
import { OfficeService } from "../shared/office.service";
import { EmpresaService } from "../../empresa/shared/empresa.service";
import { Iempresa } from "../../empresa/shared/empresa.model";

@Component({

  selector: 'app-office-new',
  templateUrl: 'office-new.component.html'
})
export class OfficeNewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;
  @Input() ID: number;

  formGroupNewOffice: FormGroup;
  msgSuccessInsert: string;
  msgErrorInsert: string;
  obligatorioMsg: string;
  office: Ioffice;
  maxLengthMsg: string;
  officeName: string;
  nomOfficeMaxLength: number;
  descripcionMaxLength: number;
  nomOfficePatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  buttonGroup: any;
  empresas: Iempresa;

  constructor(public fb: FormBuilder,
    private loaderService: LoaderService,
    private officeService: OfficeService,
    private errorService: ErrorService,
    private empresaService: EmpresaService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.office = new Office(0, "", "", "", "", "", true, "", "", "", "",0,"");
    this.msgSuccessInsert = 'Se registró satisfactoriamente';
    this.msgErrorInsert = 'Error al registrar la oficina';
    this.titlePage = 'Completa los datos de la oficina';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño máximo es de ';
    this.nomOfficeMaxLength = 100;
    this.descripcionMaxLength = 250;
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.listarEmpresa();
    this.setValuesFormBuilder();
  }

  private setValuesFormBuilder() {
    this.formGroupNewOffice = this.fb.group({
      Name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomOfficeMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      description: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE)
      ])],
      direccion: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      referencia: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.descripcionMaxLength),
      ])],
      coordenadas: [''],
    });
  }

  changeEvent(office: Ioffice) {
    this.data = { office: { ID: office.ID, Name: office.Name } };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }
  formGroupNewOfficeSubmit(event) {
    if (this.formGroupNewOffice.invalid)
      return;
    this.office.Name = event.value.Name;
    this.office.Direccion = event.value.direccion;
    this.office.Referencia = event.value.referencia;
    this.office.Coordenadas = event.value.coordenadas;
    this.office.Descripcion = event.value.description;
    this.office.Status = event.value.Status;
    this.insertarOffice(this.office);
  }

  private insertarOffice(office: Ioffice) {
    this.loaderService.show();
    this.office.Status = CONSTANT.estadoRegistro.activo;
    this.officeService.insertarOffice(office)
      .subscribe(res => {
        office.ID = res;
        this.changeEvent(office);
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          this.notificationService.error(this.msgErrorInsert);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  private listarEmpresa(): void {
    this.loaderService.show();
    this.empresaService.listEmpresa()
      .subscribe(res => {
        this.empresas = res;
      },
        error => {
          this.notificationService.error("error al lsitar empresas");
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
